/*
 * � 2020 Microsoft. All rights reserved.
 */

require.config({
    waitSeconds: 0,
    paths: {        
        'text': 'dependencies/bower_components/requirejs-text/text',
        'pixi': 'dependencies/bower_components/pixi/bin/pixi.dev',
        'absolute': 'dependencies/absolute/absolute',
        'absoluteaudio': 'dependencies/absoluteaudio/absoluteaudio',
        'state-machine': 'dependencies/bower_components/javascript-state-machine/state-machine',
        'tween': 'dependencies/bower_components/tweenjs/src/Tween',
        'fpsmeter': 'dependencies/bower_components/fpsmeter/dist/fpsmeter',
        'BigInteger': 'dependencies/bower_components/biginteger/BigInteger',
        'jszip': 'dependencies/bower_components/jszip/dist/jszip',
        'jsziputils': 'dependencies/bower_components/jszip-utils/dist/jszip-utils',
        'requireLib': 'dependencies/bower_components/requirejs/require',
        'proton': 'dependencies/bower_components/Proton/build/proton-1.0.0',
        'SoundManager': 'dependencies/bower_components/soundmanager2/script/soundmanager2',
        'ApplicationInsights': '../../node_modules/@microsoft/applicationinsights-web/dist/applicationinsights-web',
/* removed by grunt-string-replace as part of the dist:prod step */        
    },
    'packages': [
        {'name': 'lodash', 'location': 'dependencies/bower_components/lodash-amd/modern'}
    ],
    shim: {
        'state-machine': {
            exports: 'StateMachine'
        },
        'tween': {
            exports: 'TWEEN'
        },
        'fpsmeter': {
            exports: 'FPSMeter'
        },
        'BigInteger': {
            exports: 'bigInt'
        },
        'proton': {
            exports: 'Proton'
        }
    }
});
require(['version', 'absolute', 'absolute/stringmanager', 'audiosprites', 'artassets', 'gameconfig', 'game',
        'Solitaire/MvvmStructure/Service/ManifestService', 'SoundManager', 'MenuUI/DealWarningModal', 'MenuUI/WarningModal', 'pixi',
    'Managers/TelemetryManager', 'Managers/AdManager', 'Managers/ExceptionManager', 'appInsightsConfig'],
    function (
        Version, Absolute, _s, AudioSprites, ArtAssets, GameConfig,
        Game, ManifestService, SoundManager, DealWarningModal, WarningModal, PIXI, TelemetryManager, AdManager, ExceptionManager, AppInsightsConfig
    ) {

        TelemetryManager.appLaunch(AppInsightsConfig);
        
        ExceptionManager.initialize();

        // apply tinting fix if necessary
        Absolute.Platform.hasChromeTintingBug(function (hasBug) {
            if (hasBug) {
                PIXI.CanvasTinter.tintWithMultiply = function (texture, color, canvas) {
                    var context = canvas.getContext("2d");

                    var crop = texture.crop;

                    // HACK FIX here!
                    // Windows Chrome 46 introduced an issue with tinting.
                    // see: https://github.com/pixijs/pixi.js/issues/2171
                    //canvas.width = crop.width;
                    //canvas.height = crop.height;
                    canvas.width = Math.max(crop.width, 258);
                    canvas.height = Math.max(crop.height, 258);
                    // End HACK FIX

                    context.fillStyle = "#" + ("00000" + (color | 0).toString(16)).substr(-6);

                    context.fillRect(0, 0, crop.width, crop.height);

                    context.globalCompositeOperation = "multiply";

                    context.drawImage(texture.baseTexture.source,
                        crop.x,
                        crop.y,
                        crop.width,
                        crop.height,
                        0,
                        0,
                        crop.width,
                        crop.height);

                    context.globalCompositeOperation = "destination-atop";

                    context.drawImage(texture.baseTexture.source,
                        crop.x,
                        crop.y,
                        crop.width,
                        crop.height,
                        0,
                        0,
                        crop.width,
                        crop.height);
                };
                // required for the tintWIthMultiply shim to work
                PIXI.CanvasTinter.tintMethod = PIXI.CanvasTinter.canUseMultiply ? PIXI.CanvasTinter.tintWithMultiply : PIXI.CanvasTinter.tintWithPerPixel;
            }
        }, 'static/img/test-tint.png');


        var debug = false,
            forcePortrait = false,
            urlParams = {},
            match,
            pl = /\+/g,  // Regex for replacing addition symbol with a space
            search = /([^&=]+)=?([^&]*)/g,
            decode = function (s) {
                return decodeURIComponent(s.replace(pl, " "));
            },
            query = window.location.search.substring(1);

        while (match = search.exec(query)) {
            urlParams[decode(match[1])] = decode(match[2]);
        }

        debug = urlParams['debug'] && urlParams['debug'] === 'true';
        forcePortrait = urlParams['portrait'] && urlParams['portrait'] === 'true';
        Absolute.Debug.enabled = debug;

        // override res classes?
        Absolute.ScreenMetrics.resClasses = [
            {id: 'r384', resfloor: 0},
            {id: 'r768', resfloor: 384},
            {id: 'r960', resfloor: 768},
            {id: 'r1366', resfloor: 960},
            {id: 'r1536', resfloor: 1366},
            {id: 'r1920', resfloor: 1536}
        ];

        Absolute.ScreenMetrics.getResScale = function () {
            switch (this.getResClass()) {
                case 'r384':
                    return 0.2;
                case 'r768':
                    return 0.4;
                case 'r960':
                    return 0.5;
                case 'r1366':
                    return 0.7;
                case 'r1536':
                    return 0.8;
                case 'r1920':
                    return 1;
                default:
                    return 1;
            }
        };

        Absolute.ScreenMetrics.getResClass = function () {

            this.resClass = "r1920";
            return this.resClass;

            if (this.resClass !== "") {
                return this.resClass;
            }

            var w;
            if (window.parent !== window) {
                w = Math.max(document.documentElement.clientWidth, window.outerWidth || 0) * (window.devicePixelRatio || 1);
            } else {
                w = this.screenWidth * (window.devicePixelRatio || 1);
            }
            var resClassIndex = 0;
            while (resClassIndex < this.resClasses.length - 1 && w >= this.resClasses[resClassIndex + 1].resfloor) {
                resClassIndex++;
            }

            resClassIndex = Math.max(resClassIndex, 3);

            this.resClass = this.resClasses[resClassIndex].id;
            return this.resClass;
        };


        /**
            * {
                "dir": "r384",
                "scale": 0.2
            },
            {
            "dir": "r768",
            "scale": 0.4
        },
            {
            "dir": "r960",
            "scale": 0.5
        },
            {
            "dir": "r1536",
            "scale": 0.8
        },
            {
            "dir": "r1920",
            "scale": 1
        }
            */


        Absolute.Debug.log('Starting ' + '"' + Version.name() + '"' + " " + Version.id() + " " + Version.version());

        Absolute.ScreenMetrics.refresh();
        Absolute.ScreenMetrics.log();

        Absolute.Platform.artPathPrefix = 'spritesheets';
        Absolute.Platform.soundPathPrefix = 'sound';

        var startGame = function () {

            var game = new Game(
                Version.id(),
                {
                    container: 'container',
                    width: 1920 * Absolute.ScreenMetrics.getResScale(),
                    height: 1080 * Absolute.ScreenMetrics.getResScale(),
                    gameId: Version.id(),
                    gameVersion: Version.version(),
                    config: GameConfig,
                    backgroundColor: 0xaaaaaa
                }
            );

            game.load(
                {
                    audioAssets: AudioSprites,
                    artAssets: ArtAssets
                },
                function (percentComplete) {
                    Absolute.Debug.log((percentComplete * 100) + '% loaded');
                },
                function () {                    
                    ManifestService.Load(function () {
                            Absolute.Debug.log('load complete');
                            window.AHGameLoaded = true;
                            AdManager.initialize(game);
                            game.start();
                        },
                        function (error) {
                            console.info(error);
                            if (
                                error.name === 'RangeError' || error.name === 'ReferenceError'
                                || error.name === 'SyntaxError' || error.name === 'TypeError'
                            ) {
                                ExceptionManager.appException(error)
                            }
                            
                            TelemetryManager.manifestError(error.message);

                            game.start();
                            game.ui.hideLoadingScreen();
                            game.ui.showLoadingScreen();
                            var warningModal = new WarningModal(game.ui.loadingScreen.parent,
                                _s("dialogs.manifestWarningHeadline"), _s("dialogs.manifestWarningContent"),
                                function () {
                                    game.ui.hideLoadingScreen();
                                    warningModal.close()
                                });
                        });
                }
            );
        };

        if (typeof cordova !== 'undefined') {
            // for cordova
            var onDeviceReady = function () {
                document.addEventListener("pause", function (e) {
                    Absolute.MusicManager.stopMusic();
                }, false);

                document.addEventListener("backbutton", function (e) {
                    navigator.app.exitApp();
                }, false);

                startGame();
            };

            document.addEventListener("deviceready", onDeviceReady, false);
        } else if (Absolute.Platform._isIE()) {
            var sm = new SoundManager.SoundManager('code/dependencies/bower_components/soundmanager2/swf/');
            sm.setup({
                url: 'code/dependencies/bower_components/soundmanager2/swf/',
                preferFlash: true,
                useHighPerformance: true,
                flashVersion: 9,
                onready: function () {
                    startGame();
                },
                debugMode: Absolute.Debug.enabled
            });

            sm.beginDelayedInit();
            window.soundManager = sm;

        } else {
            startGame();
        }
    });

define("main", function(){});

